import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import useCallNumbersPopover from 'call-widget-addon/useCallNumbersPopover';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useThirdPartyNumbersPopover } from 'calling-integration-help-desk/help-desk/hooks/useThirdPartyNumbersPopover';
import { getAuthAsPojo } from 'conversations-thread-data/auth/public/selectors';
import { useSelector } from 'react-redux';
import { THIRD_PARTY, STANDALONE, WIDGET } from '../constants/callingSource';
import { useLastPhoneNumber } from '../utils/useLastPhoneNumber';
import { useVisitorPhoneNumber } from '../utils/useVisitorPhoneNumber';
import { jsx as _jsx } from "react/jsx-runtime";
const UnknownVisitorCallingMessage = styled.div.withConfig({
  displayName: "CallingTab__UnknownVisitorCallingMessage",
  componentId: "qkb6ct-0"
})(["padding:12px;max-width:400px;"]);
export const CallingTab = ({
  closeDropdown,
  isKnownVisitor,
  subjectId,
  callingSource,
  associatedObjectId,
  associatedObjectTypeId,
  inboxId,
  threadId
}) => {
  const auth = useSelector(getAuthAsPojo);
  const defaultFromNumber = useLastPhoneNumber({
    threadId
  });
  const visitorPhoneNumber = useVisitorPhoneNumber({
    threadId
  });
  const appIdentifier = callingSource === STANDALONE || callingSource === THIRD_PARTY ? 'help desk' : 'inbox';
  const callNumbersPopoverProps = {
    subjectId: `${associatedObjectId && associatedObjectTypeId ? associatedObjectId : subjectId}`,
    objectTypeId: associatedObjectTypeId && associatedObjectId ? associatedObjectTypeId : CONTACT_TYPE_ID,
    onCallButtonClick: closeDropdown,
    shouldFetch: true,
    appIdentifier,
    inboxId,
    threadId,
    defaultFromNumber,
    isKnownVisitor,
    visitorPhoneNumber,
    auth
  };
  const [renderedCallNumbersPopover] = useCallNumbersPopover(callNumbersPopoverProps);
  const {
    renderedThirdPartyNumbersPopover,
    isThirdPartyCallingPopoverInUse
  } = useThirdPartyNumbersPopover(callNumbersPopoverProps);
  const showThirdPartyNumbersPopover = appIdentifier === 'help desk' && isThirdPartyCallingPopoverInUse;
  return /*#__PURE__*/_jsx(UIDropdown, {
    "data-selenium-test": "editor-channel-dropdown-calling",
    buttonUse: "transparent",
    placement: "right bottom",
    caretRenderer: /*#__PURE__*/_jsx(UIIcon, {
      name: "right"
    }),
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.tabbed-editor.calling-tab.button-text"
    }),
    children: callingSource === WIDGET && !isKnownVisitor ? /*#__PURE__*/_jsx(UnknownVisitorCallingMessage, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.tabbed-editor.calling-tab.requires-associated-visitor"
      })
    }) : showThirdPartyNumbersPopover ? renderedThirdPartyNumbersPopover : renderedCallNumbersPopover
  });
};
CallingTab.displayName = 'CallingTab';